import axios from 'axios'
import { cancelPreviousRequest } from '../../component/helper'
//import { ID, Response } from '../../../../../_metronic/helpers'
//import { User, UsersQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL


const COURIER_CO_ADD = `${API_URL}/courier-company-add`
const COURIER_CO_LIST = `${API_URL}/courier-company-list`
const COURIER_CO_EDIT = `${API_URL}/courier-company-edit`
const COURIER_CO_BY_ID = `${API_URL}/courier-company-detail`
// const COURIER_CO_ALL = `${API_URL}/courier-company-all`
const COURIER_SERVICE_ALL = `${API_URL}/courier-service-all`
const PINCODE_SERVICE_AREA = `${API_URL}/pincode-service-area`

const COURIER_PARTNER_ADD = `${API_URL}/courier-partner-add`
const COURIER_PARTNER_LIST = `${API_URL}/courier-partner-list`

const COURIER_PARTNER_EDIT = `${API_URL}/courier-partner-edit`
const COURIER_PARTNER_BY_ID = `${API_URL}/courier-partner-detail`
// const COURIER_PARTNER_ALL = `${API_URL}/courier-partner-all`
const PARTNER_SPOC = `${API_URL}/partner-spoc`
const COURIER_COMPANY_ALL = `${API_URL}/courier-company-all`


const PICKUP_LOCATION_ADD = `${API_URL}/pickup-location-add`
const PICKUP_LOCATION_LIST = `${API_URL}/pickup-location-list`
const PICKUP_LOCATION_EDIT = `${API_URL}/pickup-location-edit`
const PICKUP_LOCATION_BY_ID = `${API_URL}/pickup-location-detail`
const PARTNER_ALL = `${API_URL}/pickup-location-all`


const VENDER_CO_ADD = `${API_URL}/vendor-add`
const VENDOR_CO_LIST = `${API_URL}/vendor-list`
const VENDOR_CO_EDIT = `${API_URL}/vendor-edit`
const VENDOR_CO_BY_ID = `${API_URL}/vendor-detail`

const VENDOR_CAT_MAPPING_ADD = `${API_URL}/add-vendor-catgory-mapping`
const VENDOR_CAT_MAPPING_LIST = `${API_URL}/get-vendor-catgory-mapping`
const VENDOR_CAT_MAPPING_EDIT = `${API_URL}/vendor-edit`
// const VENDOR_CAT_MAPPING_ID = `${API_URL}/vendor-detail`
const VENDOR_DOWNLOAD = `${API_URL}/vendor-download`
const VENDOR_PINCODE_LIST = `${API_URL}/vendor-pincode-list`
const VENDOR_PINCODE_UPDATE = `${API_URL}/vendor-pincode-update`
/* product end */
export const courierCompanyAdd = (query) => {
    return axios.post(COURIER_CO_ADD, query).then((d) => d.data)

}

export const courierCompanyUpdate = (query) => {
    return axios.post(COURIER_CO_EDIT, query).then((d) => d.data)
}

export const courierCompanyList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${COURIER_CO_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const getCourierCompanyId = (id) => {
    return axios.get(`${COURIER_CO_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const getCourierServiceAll = (query) => {
    return axios.post(COURIER_SERVICE_ALL, query).then((d) => d.data)
}


/* Partner api */

export const courierPartnerAdd = (query) => {
    return axios.post(COURIER_PARTNER_ADD, query).then((d) => d.data)

}
export const courierPartnerUpdate = (query) => {
    return axios.post(COURIER_PARTNER_EDIT, query).then((d) => d.data)
}

export const courierPartnerList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${COURIER_PARTNER_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const getCourierPartnerId = (id) => {
    return axios.get(`${COURIER_PARTNER_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const getCourierCompanyAll = (query) => {
    return axios.post(COURIER_COMPANY_ALL, query).then((d) => d.data)
}
export const updatePartnerSpoc = (query) => {
    return axios.post(PARTNER_SPOC, query).then((d) => d.data)
}

/* Pickup Location api */

export const pickupLcationAdd = (query) => {
    return axios.post(PICKUP_LOCATION_ADD, query).then((d) => d.data)

}
export const pickupLcationUpdate = (query) => {
    return axios.post(PICKUP_LOCATION_EDIT, query).then((d) => d.data)
}

export const pickupLcationList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${PICKUP_LOCATION_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const getPickupLcationId = (id) => {
    return axios.get(`${PICKUP_LOCATION_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const getPickupLcationAll = (query) => {
    return axios.post(PARTNER_ALL, query).then((d) => d.data)
}

export const pincodeServiceArea = (query) => {
    return axios.get(`${PINCODE_SERVICE_AREA}?${query}`).then((d) => d.data)
}

export const vendorAdd = (query) => {
    return axios.post(VENDER_CO_ADD, query).then((d) => d.data)

}

export const vendorUpdate = (query) => {
    return axios.post(VENDOR_CO_EDIT, query).then((d) => d.data)
}

export const vendorList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${VENDOR_CO_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const vendorById = (id) => {
    return axios.get(`${VENDOR_CO_BY_ID}/${id}`).then((response) => response.data?.data)
}

export const vendorCategoryAdd = (query) => {
    return axios.post(VENDOR_CAT_MAPPING_ADD, query).then((d) => d.data)

}

export const vendorCategoryUpdate = (query) => {
    return axios.post(VENDOR_CAT_MAPPING_EDIT, query).then((d) => d.data)
}

export const vendorProductCatgoryList = (query) => {
    return axios.get(`${VENDOR_CAT_MAPPING_LIST}?${query}`).then((d) => d.data)
}

export const vendorDownloadList = (query) => {
    return axios.get(`${VENDOR_DOWNLOAD}?${query}`).then((d) => d.data)
}
export const vendorPincodeList = (query) => {
    const signal = cancelPreviousRequest()
    return axios.get(`${VENDOR_PINCODE_LIST}?${query}`, { signal }).then((d) => d.data)
}

export const vendorPincodeUpdate = (query) => {
    return axios.post(VENDOR_PINCODE_UPDATE, query).then((d) => d.data)
}

// export const vendorById = (id) => {
//     return axios.get(`${VENDOR_CO_BY_ID}/${id}`).then((response) => response.data?.data)
// }

